import * as React from "react";
import { DrawdownIncomeAmendmentInstruction } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownIncomeAmendmentInstruction";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { DrawdownCalculationAction } from "../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";

interface IITFCIncomeProps extends IProcessComponentProps {
    data: DrawdownIncomeAmendmentInstruction;
    subaccountHierarchyid: string;
}

interface IITFCIncomeState {
    itfcIncomeAlert: boolean;
    itfcIncomeId: number;
}

export class ITFCIncome extends ProcessComponent<IITFCIncomeProps, IITFCIncomeState> {
    constructor(props: any) {
        super(props);
        this.state = {
            itfcIncomeAlert: false,
            itfcIncomeId: null,
        };
    }

    private validateId = (id, subAccountHierarchyId: string) => {
        if (!id) { return; }
        DrawdownCalculationAction.validateITFCIncomeId(id, subAccountHierarchyId, (d) => {
            if (!d || d.length > 0) {
                this.setState({ itfcIncomeAlert: true });
            } else {
                const _data: DrawdownIncomeAmendmentInstruction = JSON.parse(JSON.stringify(d));
                // Mock up
                _data.Income.TaxableIncomeRequiredInAddition = true;
                _data.Income.MaximumIncomePerPayment = { Amount: 1000 };
                _data.Income.MaximumInitialIncomePayment = { Amount: 1000 };
                this.props.onChange({ Income: _data.Income });
            }
        });
    };

    public render(): JSX.Element {
        let data = this.props.data
        return (
            <>
                <div className="row">
                    <div className="col-4">
                        <TextBoxEditor
                            label="ITFC Income ID (optional)"
                            validateOnTyping={false}
                            validationRules={[
                                {
                                    errorMessage: "Invalid format, please re-enter",
                                    validator: (v) => {
                                        if (!v) return true;
                                        const regex = /^\d{7}$/;
                                        return regex.test(v);
                                    },
                                },
                            ]}
                            onChange={(v) => {
                                this.setState({ itfcIncomeAlert: false, itfcIncomeId: Number(v) });
                                this.props.onChange({ ImmediateTaxFreeCashIncomeRequestId: v })

                            }}
                            maxLength={7}
                            value={data?.ImmediateTaxFreeCashIncomeRequestId?.toString()}
                            cssWrapper="control-size-245"
                        />
                    </div>
                    <div className="col-4">
                        <button
                            className="btn secondary mr-10 mt-30"
                            onClick={() => {
                                this.validateId(data?.ImmediateTaxFreeCashIncomeRequestId, this.props.subaccountHierarchyid);
                            }}
                        >
                            Validate
                        </button>
                    </div>
                </div>
                {this.state.itfcIncomeAlert && (
                    <Alert alertType={AlertType.Error} message={"ITFC request id is not valid"} />
                )}
            </>
        );
    }
}
